export default __webpack_public_path__ + "static/media/zawodniczka4.104c12dc.png";